export const isResponseFailed = (res) => {
    return res.response.success !== 'full';
};
export const isResponseSuccess = (res) => {
    return res.response.success === 'full';
};
